import {Component, Mixins, Prop, Watch} from "vue-property-decorator";
import ConstantMixin from "@mixins/constantMixin";
import {authService} from "@services/authService";

let subscriptions: any = []

@Component
export default class WsMixin extends Mixins(ConstantMixin) {

  @Prop() readonly value!: any

  get _socket(): any {
    return this.$store.state.socket || {}
  }

  get _reconnectCount() {
    return this._socket.reconnectCount
  }

  get _updates(): any {
    return this.$store.getters['main/updates']
  }
  set _updates(val: any) {
    this.$store.commit('main/setUpdates', val)
  }

  //--------------------------------

  @Watch('_socket.message')
  on_socketMessage(val: any) {
    this._wsOnMessage(val)
  }

  @Watch('_socket.isConnected')
  on_socketIsConnected(val: any) {
    if (val) this._wsSubscribe()
  }

  @Watch('_reconnectCount')
  on_reconnectCount(val: any) {
    if (!(val > 0)) return
    authService.refresh()
    if (val >= this._CONST.wsReconnextMaxCount) this.$window.location = './'
  }

  //--------------------------------

  _wsSubscribe() {
    subscriptions = [
      this._CONST.subscriptions.AdminTasksUpdate,
      this._CONST.subscriptions.LiquidityPricesUpdated,
      this._CONST.subscriptions.LiquiditySettingsUpdated,
      this._CONST.subscriptions.VolumeSettingsUpdated,
      this._CONST.subscriptions.SymbolSettingsUpdate,
      this._CONST.subscriptions.LiquidityErrorsCountChanged,
    ]

    this.$socket?.sendObj({
      subscriptions
    });
  }

  _wsOnMessage(val: any) {
    if (!val) return
    this._updates = val
  }

  _wsDisconnect(): void {
    this.$disconnect()
  }

  _wsRefresh() {
    this.$disconnect()
    this.$connect()
  }
}
